export default "__VITE_ASSET__5GkOX9L1__"